import { useEffect, useMemo } from "react";
import { useGetInfosQuery } from "store/api";
import { setLanguage as setLanguageStore } from "store/commonSlice";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { DEFAULT_LANGUAGE } from "utils/defines";
import validEnvList from '../../validEnvironnementList.json'
import useTranslation from "./useTranslation";

export const getDefaultEnvCode = () => {
  let env = 'fr';
  if(window.location.href.indexOf('pac-air-eau') > -1)  {
    env ='pac-air-eau';
    //this.checkCurrentEnvironnement(this.defaultEnv)
  } else if(window.location.href.indexOf('thermor') > -1) { //NOSONAR
    env = 'pac-air-eau'; //NOSONAR
    //this.checkCurrentEnvironnement(this.defaultEnv) //NOSONAR
  } else if(window.location.href.indexOf('pacific') > -1) { //NOSONAR
    env = 'pacific';
    //this.checkCurrentEnvironnement(this.defaultEnv)
  } else {
    env = 'fr';
    //this.checkCurrentEnvironnement()
  }
  return env;
}

const getEnvByUrl = (forcedEnv?: string) => {
  let env = window.location.pathname.split('/')[1]
  env = env.toUpperCase()
  const found = validEnvList.find((code) => code === env)
  const defaultEnv: string = getDefaultEnvCode();
  const storedEnv = localStorage.getItem('_env');
  const normalizedStoredEnv =
    storedEnv &&
    storedEnv !== "undefined" &&
    storedEnv !== "null" &&
    storedEnv.trim() !== ""
      ? storedEnv
      : null;

  if (!found) env = normalizedStoredEnv || defaultEnv;
  else if (found.toLowerCase() !== localStorage.getItem('_env')) {
    //this.logout(false)
  }

  env = forcedEnv || env.toLowerCase()
  localStorage.setItem('_env', env)
  return env;
}

export const getEnvCode = () => {
  let env;
  const defaultEnv: string = getDefaultEnvCode();
  if(window.location.href.indexOf('pac-air-eau') > -1)  {
    env =getEnvByUrl(defaultEnv);
  } else if(window.location.href.indexOf('thermor') > -1) { //NOSONAR
    env =getEnvByUrl(defaultEnv);
  } else if(window.location.href.indexOf('pacific') > -1) { //NOSONAR
    env =getEnvByUrl(defaultEnv);
    //this.checkCurrentEnvironnement(this.defaultEnv)
  } else {
    env =getEnvByUrl();
    //this.checkCurrentEnvironnement()
  }
  return env;
}

export const getEnvBrand = () => {
  return 'atlantic';
}

export const useInitTranslations = () => {
  const env = getEnvCode();
  const language = localStorage.getItem("_lang");
  const {setLanguage} = useTranslation();
  const result = useMemo(() => {
    
    return { 
      init: ()=>{
        let lang = null;
        if(env === 'pac-air-eau') lang = 'zu'
        else if(env === 'pacific') lang = 'za'
        else {
          if(lang === 'zu' || lang === 'za') lang = null
          if(language !== 'zu' && language !== 'za') lang = language
          if(!lang) lang = DEFAULT_LANGUAGE
        }
        if (lang) {
          setLanguage(lang);
        }
      }
    }

  }, []);

  return result;
}



export const useSalesNetwork = () => {
  const env = getEnvCode();
  const { data, isLoading } = useGetInfosQuery(env);
  const dispatch = useAppDispatch();
  const commonState = useAppSelector((state) => state.common);
  const language = commonState.lang ?? localStorage.getItem("_lang");

  const defaultLang = useMemo(() => {
    if (!data) return undefined;

    if (localStorage.getItem("_lang")) {
      return data.langs[0];
    }

    return language && data.langs.indexOf(language) !== -1
      ? language
      : data.langs[0];
  }, [data, language]);

  useEffect(() => {
    if (!data || localStorage.getItem("_lang") || !defaultLang) return;

    if (commonState.lang !== defaultLang) {
      dispatch(setLanguageStore(defaultLang));
    }
  }, [data, defaultLang, commonState.lang, dispatch]);

  const result = useMemo(() => {
    return { 
      network: data, 
      brand: getEnvBrand(),
      isLoading, 
      defaultLang, 
      isNeuf: env === 'nuef', 
      isAtlantic: env === 'fr',
      isEnvFr: env === 'fr' || env === 'fr-t' || env === 'pac-air-eau' || env === 'pacific' ,
      isThermor: env === 'fr-t' || env === 'pac-air-eau',
      isPacific: env === 'pacific'
    };
  }, [data, isLoading, defaultLang, env]);

  return result;
};

